// src/services/reactionsService.js
import { apiRequest } from "./apiService";

const toStr = (v) => String(v ?? "").trim();
const lower = (v) => toStr(v).toLowerCase();

export const toggleReaction = ({ creatorId, reactionType } = {}) => {
  const cid = toStr(creatorId);
  const rt = lower(reactionType);

  if (!cid) return Promise.reject(new Error("creatorId is required"));
  if (!rt) return Promise.reject(new Error("reactionType is required"));

  return apiRequest("/reactions/toggle", "POST", { creatorId: cid, reactionType: rt });
};

export const getReactionSummary = (creatorId) => {
  const cid = toStr(creatorId);
  if (!cid) return Promise.reject(new Error("creatorId is required"));

  return apiRequest(`/reactions/${encodeURIComponent(cid)}`, "GET");
};